import { safeLocalStorage } from 'utils/storage';

export const getZenModeSetting = () => safeLocalStorage.getItem('savedZenModeSetting') ?? 'true';

export const setZenModeSetting = (checked: boolean) => {
  safeLocalStorage.setItem('savedZenModeSetting', `${!checked}`);
};
